<template>
	<v-sheet color="transparent">
		<v-row class="white--background mt-12 pt-5 pb-5 extend-row" height="80vh">	
			<v-col class="text-center">
				<h1 class="cn-font primary--text mb-3 mt-10 light">Digitale Reife im Gesundheitswesen messen</h1>
				<h2 class="cn-font grey--text mb-12 mt-6 light">Analysieren Sie mit CHECK IT NOW klinische Versorgungsprozesse</h2>
				<p>
					<v-btn large color="primary2" dark rounded @click="linkTo('funktion')">Funktion</v-btn>	
				</p>
			</v-col>
		</v-row>
		<v-row class="mt-12 blue--background extend-row mb-12">
			<v-col cols="12" md="7" class="pl-4">
				<Introduction class="mb-12"></Introduction>
			</v-col>
			<v-col class="d-none d-md-block" cols="4" offset="1">
				<v-card height="100%" color="lilac" flat>
					<div class="wonky-image">
						
						<v-img src="https://checkit-now.de/wp-content/uploads/2020/08/bermix-studio-4ov6VgaiiX0-unsplash-scaled.jpg" contain></v-img>
					</div>
				</v-card>
			</v-col>
		</v-row>
		<div style="position: relative; margin-top: 120px;">
			
		<v-row class="primary--background pb-4 mb-3 extend-row" id="wonky-row">
			<v-col class="pl-6 inner">
				<h3 class="cn-font mb-6 mt-6 light">Stellen Sie mit CHECK IT NOW den richtigen Personen die richtigen Fragen und machen Sie die Digitalisierung Ihres Hauses zu einem nachhaltigen und nutzenstiftenden Erfolg.</h3>
				<p>
					Wir haben CHECK IT NOW entwickelt, um Entscheiderinnen und Entscheidern in Gesundheitseinrichtungen einen mehrdimensionalen Blick auf den eigenen Digitalisierungsgrad zu ermöglichen, der alle relevanten Akteure und deren Bedürfnisse innerhalb des Versorgungsprozesse berücksichtigt. Dabei werden langfristige Verlaufsanalysen und flexible Updates ermöglicht und zudem mit bereits genutzten Modellen abgeglichen.
				</p>
			</v-col>
		</v-row>
		</div>
		<v-row class="pb-9 pt-12">
			<v-col>
				<p class="cn-font light grey--text text-center mt-9"><span style="font-size: 2.8em;">CHECK IT NOW </span><br/> <span style="font-size: 1.2em;">Messen. Bewerten. Gestalten</span>.</p>
			</v-col>
		</v-row>
	</v-sheet>
</template>

<style lang="less">
	.primary--background {
		color: white;
		background-color: #5568F1;
	}
	.wonky-image{
		position: relative;
		top: 50px;
		left: -50px;
	}
	#wonky-row {
		.inner{

			z-index: 1;
		}
		padding-top: 0px;

	}
	#wonky-row:before {
		position: absolute;
		top: -20px;
		left: -20px;
		width: 200%;
		height: 50%;
		overflow: hidden;
		right: 0;
		bottom: 0;
		content: " ";
		// height: 50%;
		z-index: 0;
		background:  #5568F1; 	
		transform: skewY(2deg);
	}

</style>

<script type="text/javascript">
	// import Vuex from "vuex";

	import Introduction from "@/components/content/Introduction"
	
	export default {
		name: "VisitorLanding", 
		props: {
			
		},
		data: () => {
			return {

			}
		},
		components: {
			Introduction
		},
		// computed: {
			// ...Vuex.mapState({})
		// },
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>"